import { Injectable } from '@angular/core';
import { Tutorial, TutorialHostComponent } from 'components/tutorial/tutorial-host';
import { LoggingService } from 'services/logging.service';
import { MenuController } from './menu-controller';
import { timeout } from '@cf-shared/shared-util';

@Injectable()
export class TutorialController {
  tutorialHost: TutorialHostComponent = undefined;

  constructor(private logging: LoggingService, private menuCtrl: MenuController) { }

  public registerHost(host: TutorialHostComponent) {
    this.tutorialHost = host;
  }

  isReady() {
    return this.tutorialHost !== undefined && typeof this.tutorialHost.playTutorialAsync === 'function';
  }

  public async playTutorialAsync(tutorial: Tutorial) {
    if (!this.tutorialHost) {
      this.logging.trackAbnormalError("Can't queue tutorial - host not ready.");
      return;
    }
    return this.tutorialHost.playTutorialAsync(tutorial);
  }

  // tutorial must make sure it has timeouts on everything
  async waitMenuTransitionsSafe() {
    try {
      await timeout(1000, this.menuCtrl.waitMenuTransitions());
    } catch (e) {
      // all errors are silent
      this.logging.trackSilentProblem("Menu transition timeout", e);
    }
  }

  /// Make sure that the menu is visible (used when tutorial steps want to point out menu items)
  async openMenu() {
    await this.menuCtrl.waitMenuTransitions();

    if (!this.menuCtrl.isOpen()) {
      await this.menuCtrl.open();
    }

  }

  /// Use afterwards if some step has opened the menu
  async closeMenu() {
    await this.menuCtrl.waitMenuTransitions();
    if (this.menuCtrl.isOpen()) {
      await this.menuCtrl.close();
    }
  }
}
